import React from 'react'
import { useTheme } from '@mui/material'
import { getColorForSymbol } from '../../util/general'

function CircularSymbol({
                            symbol,
                            marginLeft = 16,
                            marginBT = 0,
                            marginRight = 0,
                            height = '24px',
                            width = '24px',
                            fontSize = '12px',
                            justifyContent = 'center',
                            alignItems = 'center'
                        }: {
    symbol: string,
    marginLeft?: number,
    marginBT?: number,
    marginRight?: number,
    height?: string,
    width?: string,
    fontSize?: string,
    justifyContent?: string,
    alignItems?: string
}) {
    const theme = useTheme()
    const randomColor = getColorForSymbol(symbol, theme.palette.background.default)

    // Extract the initials from the symbol name
    const initials = (symbol || '')
        .split(' ')
        .map((word) => word[0]?.toUpperCase())
        .slice(0, 2)
        .join('')

    return (
        <div
            style={{
                width: width, // Adjust the size as needed
                height: height, // Adjust the size as needed
                minHeight: height,
                minWidth: width,
                maxHeight: height,
                maxWidth: width,
                borderRadius: '50%',
                backgroundColor: randomColor,
                display: 'flex',
                justifyContent: justifyContent,
                alignItems: alignItems,
                color: 'white',
                fontSize: fontSize,
                marginLeft: `${marginLeft}px`,
                marginBottom: `${marginBT}px`,
                marginTop: `${marginBT}px`,
                marginRight: `${marginRight}px`
            }}
        >
            {initials}
        </div>
    )
}

export default CircularSymbol
